import type { Monitor, SavedMonitor } from "../types/assessment/monitor.ts";

export const convertSavedMonitor = (savedMonitor: SavedMonitor): Monitor => ({
  cta: savedMonitor.description ?? "",
  ...savedMonitor,
});
